// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.cateDel_title-cate__WWmLB {
  font-weight: 700;
  margin-top: 50px;
  font-size: 4rem;
}

.cateDel_img-content__U7qg3 {
  border-radius: 14px;
  width: 100%;
  aspect-ratio: 16/9; /* Tỷ lệ hình chữ nhật  */
  object-fit: cover;
}
.cateDel_img-content__U7qg3:hover {
  transform: scale(1.05);
  transition: transform 0.4s ease-in-out;
  cursor: pointer;
}

.cateDel_custom-card__CGXWo {
  border: none;
  cursor: pointer;
}

.cateDel_title-content__nW2j4 {
  font-weight: 600;
  font-size: 2rem;
  white-space: nowrap; /* Không cho xuống dòng */
  overflow: hidden; /* Ẩn phần nội dung bị tràn */
  text-overflow: ellipsis; /* Thêm dấu "..." khi nội dung bị tràn */
}

.cateDel_error__ROO-t {
  font-weight: 600;
  font-size: 2rem;
  padding-top: 1rem;
}

.cateDel_btn-return__khxuH {
  font-size: 1.6rem;
  color: #6c757d;
  border: solid #6c757d 1px;
  padding: 8px;
  border-radius: 8px;
}
.cateDel_btn-return__khxuH:hover {
  background-color: #6c757d;
  color: white;
}

@media (max-width: 768px) {
  .cateDel_title-cate__WWmLB {
    font-size: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/content/category/ButtonCategory/cateDel.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;AAEJ;;AAEA;EACI,mBAAA;EACA,WAAA;EACA,kBAAA,EAAA,yBAAA;EACA,iBAAA;AACJ;AACI;EACI,sBAAA;EACA,sCAAA;EACA,eAAA;AACR;;AAEA;EACI,YAAA;EACA,eAAA;AACJ;;AACA;EACI,gBAAA;EACA,eAAA;EACA,mBAAA,EAAA,yBAAA;EACA,gBAAA,EAAA,6BAAA;EACA,uBAAA,EAAA,wCAAA;AAEJ;;AACA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AAEJ;;AAAA;EACI,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AAGJ;AAFI;EACA,yBAAA;EACA,YAAA;AAIJ;;AADA;EACI;IACI,eAAA;EAIN;AACF","sourcesContent":[".title-cate{\n    font-weight: 700;\n    margin-top: 50px;\n    font-size: 4rem;\n}\n\n\n.img-content{\n    border-radius: 14px;\n    width: 100%; \n    aspect-ratio: 16 / 9; /* Tỷ lệ hình chữ nhật  */\n    object-fit: cover; \n\n    &:hover{\n        transform: scale(1.05); \n        transition: transform 0.4s ease-in-out; \n        cursor: pointer;\n    }\n}\n.custom-card {\n    border: none;\n    cursor: pointer;\n}\n.title-content{\n    font-weight: 600;\n    font-size: 2rem;\n    white-space: nowrap; /* Không cho xuống dòng */\n    overflow: hidden; /* Ẩn phần nội dung bị tràn */\n    text-overflow: ellipsis; /* Thêm dấu \"...\" khi nội dung bị tràn */\n\n}\n.error{\n    font-weight: 600;\n    font-size: 2rem;\n    padding-top: 1rem;\n}\n.btn-return{\n    font-size: 1.6rem;\n    color: #6c757d;\n    border: solid #6c757d 1px;\n    padding: 8px;\n    border-radius: 8px;\n    &:hover{\n    background-color: #6c757d;\n    color: white;\n    }\n}\n@media (max-width: 768px) {\n    .title-cate{\n        font-size: 3rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title-cate": `cateDel_title-cate__WWmLB`,
	"img-content": `cateDel_img-content__U7qg3`,
	"custom-card": `cateDel_custom-card__CGXWo`,
	"title-content": `cateDel_title-content__nW2j4`,
	"error": `cateDel_error__ROO-t`,
	"btn-return": `cateDel_btn-return__khxuH`
};
export default ___CSS_LOADER_EXPORT___;
